/**
 * A visible "there is more this way" on a sideways scroller (verification 2026-10-14, phones): while the scroller
 * holds more than it shows to the right, it carries `okb-scrollfade` (kanban.css), which fades its right edge.
 * Recomputed on scroll and on resize; nothing is hidden, the items stay where they are.
 */
import { useEffect } from 'react';
import type { RefObject } from 'react';

export const SCROLL_FADE_CLASS = 'okb-scrollfade';

export function moreToTheRight(el: { scrollLeft: number; clientWidth: number; scrollWidth: number }): boolean {
  return el.scrollLeft + el.clientWidth < el.scrollWidth - 2;
}

export default function useScrollFade(ref: RefObject<HTMLElement>, deps: unknown[] = []): void {
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof window === 'undefined') return undefined;
    const update = () => el.classList.toggle(SCROLL_FADE_CLASS, moreToTheRight(el));
    update();
    el.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    return () => { el.removeEventListener('scroll', update); window.removeEventListener('resize', update); };
    // The deps are the content that changes the scroller's width.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
